'use strict';

var React = require('react'),
    _ = require('underscore'),
    IframeForm = require('../molecules/IframeForm'),
    FormMixin = require('../mixins/FormMixin'),
    FormInputRow = require('../molecules/FormInputRow'),
    RecaptchaFormRow = require('../organisms/RecaptchaFormRow'),
    Icon = require('../atoms/Icon'),
    Button = require('../atoms/Button'),
    Link = require('../atoms/Link'),
    validateEmail = require('../utils/validateEmail'),
    validateRequiredString = require('../utils/validateRequiredString'),
    FormStore = require('../stores/FormStore'),
    ServiceTypes = require('../constants/ServiceTypes'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;


var FinishSignup = React.createClass({
  mixins: [FormMixin, PureRenderMixin],

  propTypes: {
    onCloseClick: PropTypes.func.isRequired,
    onLoginClick: PropTypes.func.isRequired,
    onTermsClick: PropTypes.func.isRequired,
    allowClose: PropTypes.bool.isRequired,
    service: PropTypes.oneOf(
      [ServiceTypes.EMAIL, ServiceTypes.FACEBOOK, ServiceTypes.TWITTER, ServiceTypes.GOOGLE]
    ).isRequired
  },

  getInitialState: function () {
    return {
      name: FormStore.getDefaultValue('name') || '',
      email: FormStore.getDefaultValue('email') || '',
      password: FormStore.getDefaultValue('password') || '',
      recaptcha: FormStore.getDefaultValue('recaptcha') || ''
    };
  },

  render: function () {
    return (
      <div className='Modal-body'>
        <div className='Modal-header'>
          <h3 className='Modal-title'>
            Almost There
          </h3>
          {this.props.allowClose &&
            <div onTouchTap={_.partial(this.props.onCloseClick, undefined)} className='Modal-close'>
              <Icon name='cross' size='small' mode='stroke' />
            </div>
          }
        </div>
        <div className='Modal-content'>
          <p className='Modal-message'>
            Finish creating your Stampsy account.
          </p>
          <IframeForm ref='signupForm' name='signup' action='/signup'>
            <FormInputRow ref='name'
                          name='name'
                          formLink={this.linkValidatedState('name', validateRequiredString)}
                          label='Full Name'
                          onKeyUp={this.handleKeyUp}
                          readOnly={!this.isFormEditable()}
                          autofill />

            <FormInputRow type='email'
                          ref='email'
                          name='email'
                          formLink={this.linkValidatedState('email', validateEmail)}
                          label='Email'
                          onKeyUp={this.handleKeyUp}
                          readOnly={!this.isFormEditable()}
                          autofill />

            {this.props.service === ServiceTypes.EMAIL &&
              [
                <FormInputRow type='password'
                            ref='password'
                            name='password'
                            formLink={this.linkValidatedState('password', this.validatePassword)}
                            label='Password'
                            onKeyUp={this.handleKeyUp}
                            readOnly={!this.isFormEditable()}
                            autofill />,
                <RecaptchaFormRow formLink={this.linkValidatedState('recaptcha', validateRequiredString)}/>
              ]
            }
          </IframeForm>
        </div>
        {this.renderFooter()}
      </div>
    );
  },

  renderFooter: function () {
    return (
      <div className='Modal-footer'>
        <Button color='green'
                size='large'
                context='Modal'
                fill
                onClick={this.submitForm.bind(this, this.sendRequest)}
                disabled={!this.isFormEditable()}>
          Sign Up
        </Button>

        <div className='Modal-footerText'>
          <span>
            By signing up you accept Stampsy’s
            {' '}
            <Link onClick={this.props.onTermsClick}>Terms of Service</Link>.
          </span>
          <br/><br/>
          {this.props.service === ServiceTypes.EMAIL &&
            <span>
              Already have an account?
              {' '}
              <Link onClick={this.props.onLoginClick}
                    color='green'
                    bold>
                Log In
              </Link>
              {'.'}
            </span>
          }
        </div>
      </div>
    );
  },

  handleKeyUp: function (e) {
    if (!this.isEnterKey(e)) {
      return;
    }

    if (!this.state.name) {
      this.refs.name.focus();
    } else if (!this.state.email) {
      this.refs.email.focus();
    } else if (this.refs.password && !this.state.password) {
      this.refs.password.focus();
    }

    this.submitForm(this.sendRequest);
  },

  validatePassword: function (password) {
    password = (password || '').trim();

    if (!password) {
      return {
        error: 'Required'
      };
    }

    if (password.length < 8) {
      return {
        error: 'Minimum 8 characters'
      };
    }
  },

  sendRequest: function () {
    return this.refs.signupForm.submit();
  }
});

module.exports = FinishSignup;



/** WEBPACK FOOTER **
 ** ./modals/FinishSignup.jsx
 **/